import { type ButtonHTMLAttributes, forwardRef } from "react";
import { cx } from "../cx";
import { Icon, type IconName } from "../Icon";
import styles from "./IconButton.module.css";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconName;
  /** Required: icon-only buttons need an accessible name. */
  label: string;
  size?: "sm" | "md" | "lg";
  iconSize?: number;
  /** `ghost` = bare icon (top bar, row actions); `outlined` = bordered square (settings back arrow). */
  appearance?: "ghost" | "outlined" | "round";
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { icon, label, size = "md", iconSize, appearance = "ghost", className, type = "button", ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      className={cx(styles.button, styles[size], styles[appearance], className)}
      {...rest}
    >
      <Icon name={icon} size={iconSize ?? (size === "sm" ? 16 : 20)} />
    </button>
  );
});
